<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf='showUsername; then fullButton; else iconButton'></ng-container>
<mat-menu #userMenu='matMenu'>
    <div mat-menu-item *ngIf='!(isDefaultUser$ | async)' (click)='showResetForm()'>
        <mat-icon svgIcon='change-password'></mat-icon>
        <span>Update Password</span></div>
    <dash-gis-logout [inMenu]='true' [showIcon]='true'></dash-gis-logout>
</mat-menu>

<ng-template #fullButton>
    <button mat-button
            [matMenuTriggerFor]='userMenu'
            matTooltip='View user options'>
        <span>{{ username$ | async }}</span>
        <mat-icon svgIcon='account_circle'></mat-icon>
    </button>
</ng-template>

<ng-template #iconButton>
    <button mat-icon-button
            [matMenuTriggerFor]='userMenu'
            matTooltip='View user options'>
        <mat-icon svgIcon='account_circle'></mat-icon>
    </button>
</ng-template>
